import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTUserDanceHistory from "../page/VTUserDanceHistory";

export default function LandingUserDanceHistory() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTUserDanceHistory/>
            <Footer/>
        </>
    );
}